/**
 * W.H.Y. — Who Has You | Scroll Animations
 * IntersectionObserver-based fade-in with stagger cascading
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var triggerOffset = isMobile ? '-200px' : '-150px';
    var staggerOffset = isMobile ? '-180px' : '-120px';

    // Individual fade-in observer
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('why-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px ' + triggerOffset + ' 0px' });

    // Stagger observer: cascade children with incremental delays
    var staggerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var container = entry.target;
          var children = container.querySelectorAll(':scope > .why-fade-in');
          var staggerVal = parseFloat(container.dataset.whyStagger) || 0.1;
          var adjustedStagger = isMobile ? staggerVal * 0.55 : staggerVal;
          var maxDelay = isMobile ? 0.35 : 1.0;

          children.forEach(function (child, i) {
            var delay = Math.min(i * adjustedStagger, maxDelay);
            child.style.setProperty('--stagger', delay.toFixed(3) + 's');
          });

          // Double rAF ensures custom properties paint before transition starts
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              children.forEach(function (child) {
                child.classList.add('why-visible');
              });
            });
          });

          staggerObserver.unobserve(container);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px ' + staggerOffset + ' 0px' });

    // Register stagger containers
    document.querySelectorAll('[data-why-stagger]').forEach(function (container) {
      staggerObserver.observe(container);
    });

    // Register individual fade-in elements NOT inside stagger containers
    document.querySelectorAll('.why-fade-in').forEach(function (el) {
      var isStaggerChild = el.parentElement && el.parentElement.hasAttribute('data-why-stagger');
      if (!isStaggerChild) {
        observer.observe(el);
      }
    });

    // Auto-apply fade-in to theme product list cards & header
    document.querySelectorAll('.section-resource-list').forEach(function (section) {
      // Header elements
      var header = section.querySelector('.section-resource-list__header');
      if (header) {
        header.classList.add('why-fade-in');
        observer.observe(header);
      }

      // Product cards — stagger them
      var items = section.querySelectorAll('.resource-list__item');
      if (items.length > 0) {
        var grid = items[0].parentElement;
        if (grid) {
          items.forEach(function (item) {
            item.classList.add('why-fade-in');
          });

          var cardStagger = isMobile ? 0.08 : 0.12;
          var cardMaxDelay = isMobile ? 0.3 : 0.6;

          var cardObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var cards = entry.target.querySelectorAll('.resource-list__item.why-fade-in');
                cards.forEach(function (card, i) {
                  var delay = Math.min(i * cardStagger, cardMaxDelay);
                  card.style.setProperty('--stagger', delay.toFixed(3) + 's');
                });
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    cards.forEach(function (card) {
                      card.classList.add('why-visible');
                    });
                  });
                });
                cardObserver.unobserve(entry.target);
              }
            });
          }, { threshold: 0.1, rootMargin: '0px 0px ' + staggerOffset + ' 0px' });

          cardObserver.observe(grid);
        }
      }
    });
  });
})();
